<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Установить'" (onOk)="ok()" >
	<div [formGroup]="form">
		<div class="form-group">
			<p>Текущая валюта:&nbsp;<span class="badge badge-info">{{oldCurrency}}</span></p>
			
			<label>Новая валюта</label>
			<select class="form-control" formControlName="newCurrency" [(ngModel)]="newCurrency">
				<option *ngFor="let _currency of supportService.currencyList" value="{{ _currency.toUpperCase() }}">
					{{ _currency.toUpperCase() }}
				</option>
			</select>
		</div>
	</div>
</base-support-modal>
